import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/home/police.d0289dc0.png';
const _withScopeId = n => (_pushScopeId("data-v-77070011"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "footer-box container"
};
const _hoisted_3 = {
  class: "footer-top"
};
const _hoisted_4 = {
  key: 0,
  alt: ""
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "footer-bottom"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "鄂ICP备14000438号-3 ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footerData, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "one-col",
      key: item.id
    }, [_createElementVNode("h4", null, _toDisplayString(item.title), 1), item.id === 'weChat7' ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_4, null, 512)), [[_directive_lazy, item.qrCode]]) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList(item.rowsContent, (con, index) => {
      return _openBlock(), _createElementBlock("p", {
        key: index,
        class: _normalizeClass({
          isEmpty: con.content === 'empty',
          canClick: con.router
        }),
        onClick: $event => $setup.clickJumpTo(con)
      }, [_createElementVNode("span", null, _toDisplayString(con.content), 1)], 10, _hoisted_5);
    }), 128))]);
  }), 128))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.goToGongXin && $setup.goToGongXin(...args)),
    class: "gongXin"
  }, [_hoisted_7, _createTextVNode("鄂公网安备 42018502004526号")]), _hoisted_8])])]);
}